import React from 'react';
import Slider, { Settings } from 'react-slick';
import CityLink from '../card/city-link';
import FANextArrow from './components/fa-next-arrow';
import FAPrevArrow from './components/fa-prev-arrow';

interface CityCarouselProps {
  state: string,
  cities: string[];
  onClick: (city: string) => void;
}

const CityCarousel: React.FC<CityCarouselProps> = ({ state, cities, onClick }) => {
  const settings: Settings = {
    className: 'city-slider px-2',
    infinite: false,
    centerMode: false,
    nextArrow: <FANextArrow />,
    prevArrow: <FAPrevArrow />,
    variableWidth: true,
    rows: 1,
    swipeToSlide: true,
  };

  if (!state || cities.length === 0) {
    return null;
  }

  return (
    <Slider {...settings}>
      {cities.map((city) => (
        <CityLink state={state} city={city} key={city} onClick={onClick} />
      ))}
    </Slider>
  );
};

export default CityCarousel;
